export enum EFollowUpStep {
  Report = 'report',
  UseCase = 'use-case',
  Consent = 'consent',
  LegalDisclaimer = 'legal-disclaimer',
}
